import { createActorContext } from '@xstate/react'
import { multiCartReviewMachine } from './multiCartReviewMachine'

export const MultiCartReviewMachineContext = createActorContext(multiCartReviewMachine)
